import {REQUEST_STATE} from '@/iamteacherpc/consts/request.js';
import {ANSWER_TYPE} from '@/common/consts/survey.js';
import {getNextSequence} from '@/iamteacherpc/utils/sequence.js';
import {ImageManagerForPayload} from '@/iamteacherpc/utils/image.js';

const converter = {
    '1': convertToFromV1,
    2: convertToFromV2,
    3: convertToFromV3,
    4: pass,
};

/**
 * 이전 버전 페이로드에서 최신 페이로드로 변경
 * @param payload
 * @returns {*}
 */
export function convertToLatestSurveyPayload(payload) {
    return converter[payload.version](payload);
}

/**
 * 최신 버전인 경우 그대로 다시 반환
 * @param payload
 * @returns {*}
 */
function pass(payload) {
    return payload;
}

/**
 * 버전 1에서 변경
 * @param payload
 * @returns {*}
 */
function convertToFromV1(payload) {
    const imageManager = new ImageManagerForPayload();

    function getQuestions(questions/* 변환되지 않은 정보 */, parentQuestion/* 변환된 정보 */) {
        return questions.map(question => {
            const hasAnswer = question.type === ANSWER_TYPE.ONE_CHOICE || question.type === ANSWER_TYPE.MULTI_CHOICE;

            const newQuestion = {
                questionNo: '' + question.questionNo,
                questionNumber: question.questionNumber,
                question: question.question,
                image: question.image && imageManager.setOrGetImage({...question.image, uploadState: REQUEST_STATE.SUCCESS}) || null,
                mandatory: question.mandatory,
                type: question.type,

                ...(parentQuestion ? {
                    parentQuestionNo: '' + parentQuestion.questionNo,
                    parentAnswerCondition: question.parentQuestionCondition.map(answerIndex => parentQuestion.answers[answerIndex].answerNo)
                } : {}),

                ...(question.type === ANSWER_TYPE.MULTI_CHOICE ? {
                    maxChoice: 0
                } : {}),

                ...(question.type === ANSWER_TYPE.TEXT ? {
                    textLength: question.textLength
                } : {}),

                ...(hasAnswer ? {
                    answers: question.answers.map((answer, index) => ({
                        answerNo: getNextSequence(),
                        answerNumber: '' + (index + 1),
                        text: answer.text,
                        image: answer.image && imageManager.setOrGetImage({...answer.image, uploadState: REQUEST_STATE.SUCCESS}) || null,
                    }))
                } : {})
            };

            newQuestion.questions = question.subQuestions ? getQuestions(question.subQuestions, newQuestion) : [];

            return newQuestion;
        });
    }

    return convertToFromV2({
        version: 2,
        type: 'SURVEY',
        image: payload.image && imageManager.setOrGetImage({
            ...payload.image,
            uploadState: REQUEST_STATE.SUCCESS,
        }) || null,
        questions: getQuestions(payload.questions, null),
    });
}

/**
 * 버전 2에서 변경
 * @param payload
 * @returns {*}
 */
function convertToFromV2(payload) {
    return convertToFromV3({
        version: 3,
        images: payload.image ? [payload.image] : [],
        ...payload,
    });
}

function convertToFromV3(payload) {
    function getQuestions(questions) {
        return questions.map(question => ({
            ...question,
            isUseQuestion: true,
            questions: getQuestions(question.questions),
        }));
    }

    return {
        version: 4,
        ...payload,
        questions: getQuestions(payload.questions),
    }
}

export const v1PayloadSample = {
    version: '1',
    image: {
        imageNo: '1',
        url: 'http',
    },
    questions: [
        {
            questionNo: 1,
            questionNumber: '1',
            question: 'Q',
            mandatory: false,
            type: 'ONE_CHOICE',
            image: {
                imageNo: '2',
                url: 'http'
            },
            answers: [
                {
                    text: 'A1',
                    image: {
                        imageNo: '3',
                        url: 'http'
                    }
                },
                {
                    text: 'A2',
                    image: {
                        imageNo: '4',
                        url: 'http'
                    }
                }
            ],
            subQuestions: [
                {
                    image: null,
                    questionNo: 2,
                    questionNumber: '1-1',
                    question: 'S1',
                    mandatory: false,
                    type: 'MULTI_CHOICE',
                    parentQuestionAnswerCount: 2,
                    parentQuestionCondition: [0],
                    parentQuestionNumber: '1',
                    sub: true,
                    subQuestions: [],
                    answers: [
                        {
                            text: 'S1A1',
                            image: {
                                imageNo: '3',
                                url: 'http'
                            }
                        },
                        {
                            text: 'S1A2',
                            image: {
                                imageNo: '4',
                                url: 'http'
                            }
                        }
                    ]
                },
                {
                    image: null,
                    questionNo: 3,
                    questionNumber: '1-2',
                    question: 'S2',
                    mandatory: false,
                    type: 'TEXT',
                    textLength: 'SHORT',
                    parentQuestionAnswerCount: 2,
                    parentQuestionCondition: [1],
                    parentQuestionNumber: '1',
                    sub: true,
                    subQuestions: [],
                }
            ]
        },
        {
            image: null,
            mandatory: false,
            question: "Q2",
            questionNo: 1566890209000,
            questionNumber: "2",
            subQuestions: [],
            textLength: "SHORT",
            type: "TEXT"
        }
    ]
};
